import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Tilbake',
      changePassword: 'Endre passord',
      copiedVaultId: 'Kopiert!',
      copyVaultID: 'Kopier Vault ID',
      create: 'Opprett',
      next: 'Neste',
      notSure: 'Jeg er usikker',
      signUp: 'Registrer deg',
      submit: 'Send',
      updatePassword: 'Oppdater passord',
    },
    Errors: {
      createReportFailed: 'Opprettelse av rapport var mislykket.',
    },
    ReportStatus: {
      CLOSED: 'Lukket',
      INVESTIGATING: 'Undersøker',
      NEW: 'Sendt',
      READ: 'Les',
    },
    general: {
      navbar: {
        caseSettings: 'Sakinnstillinger',
        changePassword: 'Endre passord',
        logOut: 'Logg ut',
        notifications: 'Varsler',
        notificationsDrawer: {
          appFileScanFailed: 'En fil har mislyktes sikkerhetssjekk',
          appReportMatch: 'GoTogether-opptaket ditt har blitt samsvart',
          appReportReassigned: 'En ny saksbehandler har blitt tildelt',
          case: 'Sak',
          caseAssigned: 'Sak tildelt deg',
          caseImporterJobCompleted: {
            PartialSuccess: 'Din sakimport ble fullført med feil',
            failure: 'Importen av saken din mislyktes',
            success: 'Saken din import ble fullført med hell',
          },
          caseLinked: 'Sak knyttet',
          caseTeamInvite: 'Lagt til i sak',
          caseUnlinked: 'Sak frakoblet',
          dataSanitisation: 'Rapportdetaljer oppdatert',
          emptyDescription: 'Kom tilbake senere for nye varsler',
          emptyTitle: 'Du er helt oppdatert',
          importId: 'Import ID:',
          learnMore: 'Lær mer',
          markAllAsRead: 'Merk alt som lest',
          newMessage: 'Ny melding',
          newReport: 'Ny rapport mottatt',
          permissionRemoved: 'Fjernet fra sak',
          postSSubmissionFile: 'Bevisfil(er) lagt til',
          report: 'Rapport',
          reportAssigned: 'Rapport tildelt deg',
          reportStatusChange: 'Rapportstatus endret',
          reporterAnonymised: 'Dine detaljer har blitt anonymisert',
          reporterReportSubmitted: {
            subtitle: 'Vi anbefaler at du lagrer en kopi av rapporten din',
            title: 'Rapport innsendt',
          },
          mitigationPlanReminder: 'Godkjenning av tiltaksplan påkrevd',
          staleCase: 'Uhåndtert sak',
        },
        privacyStatement: 'Personvernerklæring',
        reporter: {
          myReports: 'Mine rapporter',
        },
        settings: 'Innstillinger',
        technicalSupport: 'Teknisk støtte',
        title: 'Konto',
      },
      time: {
        day: 'Dag',
        days: 'Dager',
        hour: 'Time',
        hours: 'Timer',
        minute: 'Minutt',
        minutes: 'Protokoll',
        second: 'Sekund',
        seconds: 'Sekunder',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonym',
        autoTranslate: 'Auto-oversettelse er slått av som standard.',
        backToMessages: 'Tilbake til meldinger',
        caseSettings: 'Sakinnstillinger.',
        changeInProfile:
          'Hvis du ønsker å endre denne innstillingen, kan du gjøre det i profilen din',
        deletedByMessage: 'Slettet av {{author}}',
        deletedMessageLabel: 'Denne meldingen ble slettet',
        description:
          'Når automatisk oversettelse er slått på, vil alle rapportmeldinger automatisk oversettes ved hjelp av AI basert på det standard språket som er valgt på nettleseren din.',
        descriptionSecondHalf:
          'Den opprinnelige versjonen av alle meldinger bevares alltid og kan bli funnet i chatten.',
        messagePlaceholder: 'Start å skrive...',
        messageSettings: 'Meldingsinnstillinger.',
        originalMessages: 'Opprinnelig',
        showMoreBanner: 'Lær mer om automatisk oversetting',
        titlev2: 'Les alle meldingene på ditt foretrukne språk.',
        translatedMessageLabel: 'Oversatt melding',
        translatedMessages: 'Oversatt',
        understood: 'Forstått',
      },
      Country: {
        description: 'I hvilket land er du basert?',
        header: 'I hvilket land er du basert?',
        noOptions: 'Ingen land funnet',
        other: 'Annet',
        placeholder: 'Søk etter et land...',
      },
      CreatePublicReport: {
        createReport: 'Opprett et nytt passord',
        helpPage: 'Gå til hjelpesiden vår',
        loginToOpr: 'Logg inn for å spore rapporter',
        or: 'eller',
        passwordPlaceholder: 'Angi passord',
        phoneNumberLoginFailed:
          'Innlogging mislyktes, telefonnummer / pin er feil',
        phoneNumberPlaceholder: 'Skriv inn ditt telefonnummer',
        phoneNumberTooltip:
          'Skriv inn telefonnummeret du brukte for å kontakte VaultTalk',
        pinPlaceholder: 'Tast inn PIN',
        reportIntroductionParagraph1:
          'Når du rapporterer en hendelse, blir du stilt noen spørsmål for å støtte deg i dokumenteringen av opplevelsen din.',
        reportIntroductionParagraph2:
          'Før du sender inn, har du muligheten til å forbli anonym for å beskytte ditt privatliv.',
        reportIntroductionParagraph3:
          'Etter at du har sendt inn, kan du logge inn når som helst for å se fremdriften i rapporten din og snakke med en saksbehandler.',
        reportIssue: 'Rapporter et problem',
        usernameLoginFailed: 'Innlogging mislyktes, brukernavn/passord er feil',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Forholdet til selskapet er nødvendig',
            reportedCategoryRequired: 'Rapportert kategori er nødvendig',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Skriv inn din e-post eller Vault ID',
        vaultIdTooltip:
          'For anonyme rapporter er Vault ID alfanumerisk. Hvis rapporten ikke var anonym, er Vault ID e-postadressen din',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ditt Passord',
        yourPhoneNumber: 'Ditt telefonnummer',
        yourPin: 'Din 6-sifret pin',
        yourVaultId: 'Din Vault-ID',
      },
      CustomHeader: {
        companyLogo: 'Selskapslogo',
        openReporting: 'Åpne rapport',
        userSettings: 'Brukerinnstillinger',
      },
      Date: {
        approximateDescription:
          'Husker du omtrent hvilken dato hendelsen fant sted?',
        approximatePlaceholder:
          'Eksempel: 6 måneder siden / i fjor / sist november',
        cancel: 'avbryt',
        clear: 'slett',
        description: 'Husker du hvilken dato hendelsen fant sted?',
        header: 'Hvilken dag skjedde det?',
        ok: 'ok',
        placeholder: 'Eksempel: 21. juni 2020',
      },
      Description: {
        whatHappened: 'Hva skjedde?',
        whatHappenedPlaceholder: 'Bruk dine egne ord...',
        whatHappenedText: 'Beskriv hva som skjedde med dine egne ord',
      },
      Details: {
        disclaimer:
          'Disse detaljene vil bli offentliggjort med rapporten din. Hvis du ønsker å forbli anonym, sørg for at de ikke inneholder identifiserende informasjon.',
        emailPlaceholder: 'E-post (valgfritt)',
        fullNamePlaceholder: 'Fullt navn (valgfritt)',
        header: 'Dine opplysninger',
        nonAnonSubtitle:
          'Vennligst oppgi enten ditt navn eller en e-postadresse. Hvis du ønsker å motta varsler om denne rapporten, legg til en passende e-postadresse nedenfor.',
        nonOptionalEmailPlaceholder: 'E-post',
        nonOptionalFullNamePlaceholder: 'Fullt Navn',
        subtitle:
          'Hvis du ønsker å motta varsler om denne rapporten, legg til en passende e-postadresse nedenfor.',
      },
      Emotion: {
        description: 'Hvordan følte du deg? Hva var konsekvensen?',
        header: 'Hva var konsekvensen?',
        placeholder: 'Begynn å skrive..',
      },
      Evidence: {
        addedHeading: 'Lagt til',
        deletedMessage: 'ble slettet',
        deletedStatus: 'Slettet',
        failedToOpenFileMessage: 'Kunne ikke åpne filen. Vennligst prøv igjen.',
        fileStatuses: {
          infectedUpload: 'Flagget av sikkerhetskontroll',
          passedUpload: 'Bestått sikkerhetskontroll',
          pendingUpload: 'Sikkerhetssjekk pågår',
          readyForDownload: 'Klar for nedlasting',
        },
        mobileErrorMessage: 'Merkede filer: meld din saksbehandler',
        nameHeading: 'Navn',
        statusHeading: 'Status',
        tableTitle: 'Bevis',
        webErrorMessage:
          'Flaggede filer: Hvis filen(e) dine har blitt flagget, vennligst send melding til saksbehandleren.',
      },
      FileUpload: {
        addFiles: 'Legg til filer',
        addMoreFiles: 'Legg til flere filer',
        confirm: 'Bekreft',
        description:
          'Å legge til filer som bevis kan hjelpe saksbehandleren din med å løse saken mer effektivt. Vennligst vurder filinnholdet (inkludert filmetadata) hvis du ønsker å være anonym, og respekter andres rettigheter og gjeldende lover.',
        dragDrop: 'Slipp filer her eller',
        errorMessage:
          'Fil(er) mislyktes på grunn av en nettverksfeil. Klikk under for å sende melding til saksbehandleren din for hjelp',
        fileLimit: 'Hver filstørrelsesgrense: 100MB',
        fileUploadLimitText: 'Du kan bare laste opp 10 filer',
        header: 'Legg til bevis',
        helpArticle: 'hjelpeartikkel',
        highlighted: 'bla gjennom filer',
        information: 'Støttede filtyper',
        moreInformation:
          'For mer info, vennligst se denne <a>hjelpeartikkel</a>',
        postSubmissionErrorMessage:
          "Vi kunne ikke laste opp filene dine på grunn av en systemfeil. Vennligst velg 'bekreft' igjen.",
        tooltipAudio: 'Lyd:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenter:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Bilder:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Tekst:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Filen er for stor',
          invalidFileType: 'Ustøttet filtype: {{extension}}',
          systemError: 'Systemfeil',
          tooManyFiles: 'Maksimalt antall filer er {{maxFiles}}',
        },
        uploadFiles: 'Last opp filer',
      },
      Loading: {
        loading:
          'Vennligst vent mens vi sender rapporten din til en saksbehandler...',
        postSubmissionLoading:
          'Vennligst vent mens vi sender inn filene dine...',
      },
      Location: {
        description: 'Hvor skjedde dette?',
        header: 'Hvor skjedde dette?',
        placeholder: 'Eksempel: På kontoret',
      },
      MessageListBox: {
        messageCaseManager: 'Melding til saksbehandler',
        report: 'Rapport {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Oversettelse deaktivert',
        enableTranslationLabelEnabled: 'Oversettelse aktivert',
        enableTranslationsDescription:
          'Aktiver automatisk oversettelse og les alle rapportmeldinger i ønsket språk. Det oversatte språket er basert på språket som er valgt på enheten din.',
        enableTranslationsHeader:
          'Aktiver automatisk oversettelser for rapportmeldinger',
        enableTranslationsSubDescriptionv2:
          'Du kan bytte mellom oversatt og original språk i hver chat.',
        updateTranslationFailed: 'Oppdatering av oversettelse mislyktes',
        updateTranslationSuccess:
          'Innstilling for oversettelse oppdatert vellykket',
      },
      Password: {
        changePasswordHeader: 'Endre passord',
        createNewPassword: 'Vennligst opprett et nytt passord',
        createPasswordHeader: 'Ditt passord',
        currentPasswordPlaceholder: 'Angi gjeldende passord',
        description:
          'Et gyldig passord må ha minst 9 tegn og inkludere minst en stor bokstav og ett tall',
        enterCurrentPassword: 'Vennligst angi ditt gjeldende passord.',
        forgottenPasswordInstructions:
          'Skriv inn din alfanumeriske Vault-ID (ikke din e-postadresse) og e-postadresse for å tilbakestille passordet ditt.',
        newDescription:
          'Lag et sterkt passord for å holde kontoen din sikker. Begynn å skrive for å se retningslinjer nedenfor.',
        passwordPlaceholder: 'Lag et nytt passord',
        passwordResetRequestedDescription:
          'Hvis din Vault ID finnes i systemet vårt, vil du motta en e-post med instruksjoner for å tilbakestille passordet ditt.',
        passwordResetRequestedHeader:
          'Tilbakestillingslenke for passord forespurt',
        reenterPlaceholder: 'Angi det nye passordet igjen',
        subtitle:
          'Opprett et passord for å sende denne rapporten og få adgang til den i framtiden',
        yourVaultId: 'Din Vault ID',
        yourVaultIdPlaceholder: 'Oppgi din Vault-ID (f.eks. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Rapporterer du en bestemt person eller flere personer? Kan du navngi eller beskrive dem?',
        header: 'Mennesker involvert',
        placeholder:
          'Begynn å skrive og bruk komma for å angi flere navn eller beskrivelser',
      },
      PoweredByVault: 'Levert av {{company}}',
      PrivacyStatement: 'Produktets personvernerklæring',
      PublicMessageList: {
        myMessages: 'Mine meldinger',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bevis lagt til i eksisterende rapport',
        backToReportId: 'Tilbake til rapport ID: {{reportId}}',
        description:
          'Å legge til filer som bevis kan hjelpe å støtte effektiviteten av løsningen av saken din av saksbehandleren din. Vennligst vurder filinnholdet (inkludert filmetadata) hvis du ønsker å være anonym, og respekter andres rettigheter og gjeldende lover. For mer info, vennligst se dette <a>hjelpeartikkel</a>',
        header: 'Legg til ytterligere bevis i rapporten',
        vaultTalkOpenCaseHeader: 'Legg til bevis i rapporten din',
      },
      PublicReport: {
        anonymous: 'Anonym',
        backToReports: 'Tilbake til rapporter',
        skipped: 'Hoppet over',
      },
      PublicReportCard: {
        addEvidence: 'Legg til ekstra bevis',
        messageCaseManager: 'Melding til saksbehandler',
        reportId: 'Rapport-ID:',
        submitted: 'Sendt',
        vaultTalkClosedCaseCTA: 'Se bevis',
        vaultTalkOpenCaseCTA: 'Legg til bevis',
        viewAdditionalEvidence: 'Se ekstra bevis',
        viewReport: 'Vis rapport',
      },
      PublicReportsList: {
        reportingSystem: 'Rapportere system',
      },
      Question: {
        placeholder: 'Begynn å skrive...',
        question: 'Oppgi detaljer',
        questionText:
          'Vennligst del din bekymring, oppdatering, eller forespørsel med oss.',
      },
      Relationship: {
        header: 'Ditt forhold til organisasjonen',
        tellUsAbout: 'Fortell oss om ditt forhold til organisasjonen.',
      },
      ResponsiveNavMenu: {
        messages: 'Mine meldinger',
        reports: 'Mine rapporter',
      },
      Site: {
        description: 'Hvilket sted er du basert på?',
        header: 'Hvilket sted er du basert på?',
        noOptions: 'Ingen steder funnet',
        other: 'Annet',
        placeholder: 'Søk etter et sted...',
      },
      SpamPuzzle: {
        dialog: 'For å fortsette må du løse denne gåtn',
      },
      SubmissionTypes: {
        reportIssue: 'Velg en kategori',
        whatType: 'Velg kategorien som best beskriver din rapport',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{category}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Innsendt dato:</bold> {{date}}',
        recordYourVaultID: 'Husk denne informasjonen for innlogging',
        successInformation: 'Mer informasjon',
        successMessage:
          'Rapporten din er sendt inn og er klar for gjennomgang. Alle vedlagte filer som krever oppmerksomhet vil bli merket ved innlogging. Logg inn nedenfor for å se rapportoppdateringer og sende melding til saksbehandleren din.',
        successSanitationMessage:
          'Lagre en kopi for dine registreringer, og hold din Vault-ID sikker - du vil trenge den for å få tilgang til oppdateringer og sende meldinger til saksbehandleren din.',
        successSanitationTagline:
          'Rapporten din ble sendt inn og sikkert lagret.',
        successThankYou: 'Takk for rapporten din!',
        viewReport: 'Vis rapport',
      },
      Time: {
        approximateDescription:
          'Husker du omtrent klokkeslettet hendelsen fant sted?',
        approximatePlaceholder: 'Eksempel: om morgenen, om ettermiddagen',
        description: 'Husker du klokkeslettet hendelsen fant sted?',
        header: 'Hvilket klokkeslett skjedde dette?',
        invalidTime: 'Tidsformatet skal være TT:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Endre passord',
        closeDialog: 'Lukk dialog',
        logout: 'Logg ut',
        messageSettings: 'Meldingsinnstillinger',
        userSettings: 'Brukerinnstillinger',
      },
      Witnesses: {
        description:
          'Har du fortalt noen andre om det som skjedde eller var det noen andre som så det som skjedde?',
        header: 'Var det noen vitner?',
        placeholder: 'Begynn å skrive..',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Send melding',
        title: 'Melding Saksbehandler',
        translationHeader: 'Lær mer om automatisk oversettelser',
      },
      ReportCard: {
        addEvidence: 'Legg til bevis',
        submissionModeVia: 'via {{innsendingsmodus}}',
        viewEvidence: 'Se bevis',
      },
      ReportList: {
        yourReports: 'Dine rapporter',
      },
      ReportingActivate: {
        buttonText: 'Fortsett',
        description:
          'Hvis organisasjonen din har registrert deg for en konto, vil vi sende deg en e-post med instruksjoner for å fullføre oppsettet.',
        emailInput: 'Epost',
        header: 'Skriv inn din jobb-e-post',
        successAccount:
          'Hvis organisasjonen din har registrert deg for en konto, vil vi sende deg en e-post med instruksjoner for å fullføre oppsettet.',
        successEmail:
          'Hvis du ikke umiddelbart ser det, vennligst vent noen minutter og oppdater e-postinnboksen din.',
        successHeading: 'Takk',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Legg til bevis i rapporten din',
        descriptionText:
          'Å legge til filer som bevis kan hjelpe til med å støtte effektiviteten til løsningen av saksbehandleren din. Vennligst vurder innholdet i filen (inkludert filmetadata) hvis du ønsker å forbli anonym, og respekter andres individuelle rettigheter og gjeldende lover. For mer info, vennligst se denne <a>hjelpeartikkelen</a>',
        emptyMessage: 'Ingen ytterligere bevis lastet opp',
      },
      ReportingChangePassword: {
        back: 'Tilbake',
        description:
          'Opprett et sterkt passord for å holde kontoen din sikker. Begynn å skrive for å se retningslinjer nedenfor.',
        errorToast: 'Kan ikke opprette passord, ugyldig token.',
        header: 'Endre passord',
        incorrectCurrentPassword:
          'Det nåværende passordet er feil. Vennligst sjekk det og prøv igjen.',
        invalidToken: 'Ugyldig token',
        passwordUpdated: 'Passord oppdatert',
        passwordUpdatedDescription:
          'Passordet ditt har blitt oppdatert. Takk for at du tar dette steget for å holde dataene dine sikre!',
        passwordUsedBefore: 'Gjenbruk av passord er ikke tillatt',
        passwordUsedBeforeDescription:
          'For din sikkerhet, kan du ikke gjenbruke noen av dine siste seks passord. Vennligst velg et nytt, unikt passord for å holde kontoen din sikker og prøv igjen.',
        toastDescription:
          'Passordet ditt har blitt oppdatert. Takk for at du tar dette steget for å holde dataene dine sikre!',
        toastMessage: 'Passord oppdatert',
        updatePasswordCTA: 'Oppdater passord',
      },
      ReportingConnect: {
        cancelButton: 'Avbryt',
        connectButton: 'Koble til',
        disclaimer:
          'Å koble Slack-kontoen din til Vault-kontoen din sikrer en trygg og privat forbindelse.<br /><br />Ved å koble sammen, kan du rapportere upassende oppførsel eller stille et spørsmål direkte innenfor Slack. Du vil alltid ha muligheten til å rapportere anonymt etter tilkobling. Ditt personvern og sikkerhet er våre topp prioriteringer.',
        heading:
          'Vault Platform ber om tillatelse til å få tilgang til din {{organisationName}} Slack-konto',
        listHeading: 'Hva vil Vault være i stand til å gjøre?',
        permissionIdentity: {
          extraInfo: 'Vault vil ha evnen til å se Slack-brukerens identitet',
          heading: 'Se informasjon om en brukers identitet',
        },
        permissionNotifications: {
          extraInfo:
            'Vault vil kunne sende deg varsler til din Slack-konto, angående oppdateringer til en innsendt rapport eller spørsmål',
          heading: 'Send deg varsler',
        },
        permissionOverview: {
          extraInfo:
            'Vault vil vise en oversikt over alle innsendinger på hjemmesiden',
          heading: 'Oversikt over innsendinger',
        },
        permissionSubmitReport: {
          extraInfo:
            'Dette vil gi Vault tillatelse til å sende inn en rapport eller stille et spørsmål, direkte til organisasjonen din, fra Slack',
          heading: 'Send inn en rapport eller spørsmål på dine vegne',
        },
        successfulConnectionDescription:
          'Din Vault-konto og Slack-konto er nå koblet sammen. Du kan nå lukke denne fanen og returnere til Slack.',
        successfulConnectionHeading: 'Vellykket tilkoblet',
        unsuccessfulConnectionDescription:
          'Noe gikk galt. Vennligst lukk denne fanen og gå tilbake til Slack for å prøve igjen.',
        unsuccessfulConnectionHeading: 'Tilkobling mislyktes',
      },
      ReportingForgotPassword: {
        description:
          'Skriv inn e-postadressen som er knyttet til kontoen din, og vi vil sende deg en link for å tilbakestille passordet ditt.',
        heading: 'Glemt passord',
        invalidTokenError: 'Kan ikke opprette passord, ugyldig token.',
        passwordReuseError: 'Gjenbruk av passord er ikke tillatt',
        passwordReuseErrorDescription:
          'For din sikkerhet kan du ikke gjenbruke noen av de siste seks passordene dine. Vennligst velg et nytt, unikt passord for å holde kontoen din sikker og prøv igjen.',
        sendLink: 'Send tilbakestillingslenke',
        sendLinkFailure: 'Noe gikk galt',
        sendLinkFailureDescription:
          'Gå tilbake til <a> Reporter Hub </a> og prøv igjen. Hvis problemet fortsetter, kontakt oss på <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Passord tilbakestillingslenke sendt',
        sendLinkSuccessDescription:
          'Vi har sendt en lenke for å tilbakestille passordet til {{email}}',
        updatePasswordSuccess: 'Passord oppdatert',
        updatePasswordSuccessDescription:
          'Passordet ditt har blitt oppdatert. Takk for at du tar dette steget for å holde dataene dine sikre!',
      },
      ReportingLogin: {
        accountFrozen: 'Kontoen er frosset',
        accountLocked:
          'Innlogging har blitt forsøkt for mange ganger feilaktig. Kontoen er låst i opptil 1 time. Tilbakestilling av passord er ikke mulig i løpet av denne tiden.',
        accountLockedPermanently:
          'Kontoen din har blitt låst. Bruk tilbakestill passord for å gjenopprette tilgang, eller kontakt systemadministratoren din for ytterligere hjelp.',
        createAccountCTA: 'Registrer deg for en konto',
        currentPassword: 'Nåværende passord',
        emailLabel: 'Din e-post',
        forgotPassword: 'Glemt passordet ditt?',
        loginButton: 'Logg inn',
        newPasswordPlaceholder: 'Ny passord',
        passwordFailMessage:
          'Gå tilbake til Vault-appen i Slack og prøv igjen. Hvis problemet fortsetter, kontakt oss på techsupport@vaultplatform.com',
        passwordFailTitle: 'Noe gikk galt',
        passwordLabel: 'Ditt Passord',
        passwordPlaceholder: 'Skriv inn passordet ditt',
        passwordResetRequired: 'Passord tilbakestilling kreves',
        passwordSuccessfullySetMessage:
          'Gå tilbake til Vault-appen i Slack og autentiser deg med ditt nye passord for å fortsette der du slapp.',
        passwordSuccessfullySetTitle: 'Passordet er vellykket satt',
        reenterPlaceholder: 'Skriv inn passordet på nytt',
        title: 'Reporter Hub',
        tooltip:
          'Hvis du aldri har satt et passord for Vault-appen ennå, følg her for å komme i gang. Hvis du har glemt passordet ditt, bruk "Glemt passord" -lenken nedenfor.',
        usernameLoginFailed:
          'Innlogging mislyktes, brukernavn eller passord er feil',
      },
      ReportingReset: {
        failureDescription:
          'Gå tilbake til Vault-appen i Slack og prøv igjen. Hvis problemet fortsetter, ta kontakt med oss på <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Noe gikk galt',
        successDescription:
          'Gå tilbake til Vault-appen i Slack og autentiser med ditt nye passord for å fortsette der du slapp',
        successHeading: 'Passordet er vellykket satt',
      },
      noReports: {
        description:
          'Alle innsendte rapporter vil vises her. Lær mer om måtene du kan sende inn en rapport på',
        descriptionHelpArticle: 'denne hjelpeartikkelen',
        errorDescription:
          'Vi sliter med å laste rapportene dine. Vennligst prøv å oppdatere siden.',
        errorDescriptionSecondary:
          'Hvis det ikke fungerer, vennligst kontakt oss på',
        errorTitle: '⚠️ Oops, noe har gått galt',
        title: 'Du har ingen rapporter ennå',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktiver auto-oversettelser og les alle rapportmeldinger på ditt foretrukne språk. Det oversatte språket er basert på språket som er valgt på enheten din.',
          autoTranslationDescription2:
            'Du kan bytte mellom oversatt og originalt språk i hver chat.',
          autoTranslationTitle:
            'Aktiver automatisk oversettelse for rapportmeldinger',
          header: 'Meldingsinnstillinger',
          subHeader: 'Konfigurer hvordan meldinger vises',
        },
        notificationSettings: {
          emailDescription:
            'Motta e-postvarsler for viktige oppdateringer til rapportene dine',
          emailTitle: 'E-postvarsler',
          header: 'Varslingsinnstillinger',
          subHeader: 'Konfigurer hvordan du mottar varsler',
        },
        title: 'Innstillinger',
        updatedSettingsFailure: 'Kunne ikke oppdatere innstillingene dine',
        updatedSettingsSuccess:
          'Oppdatering av innstillingene dine var vellykket',
      },
    },
    validators: {
      passwordLength: 'Passordet må ha minst 9 tegn',
      passwordLowercase: 'Passordet må inneholde minst 1 liten bokstav',
      passwordMissMatch: 'Passord- og bekreftelsesfeltene må matche.',
      passwordNumeric: 'Passordet må inneholde minst 1 tall',
      passwordUppercase: 'Passordet må inneholde minst 1 stor bokstav',
    },
    validatorsNew: {
      passwordLength: 'Mellom 10 og 30 tegn',
      passwordLowercase: 'Minst ett småbokstav',
      passwordMissMatch: 'Passordene stemmer ikke overens',
      passwordNumeric: 'Minst ett nummer',
      passwordSpecialCharacter: 'Minst ett spesielt tegn',
      passwordUppercase: 'Minst en stor bokstav',
    },
  },
};

export default translations;
